import React from 'react';

interface Props {
  cond: boolean;
  children: React.ReactNode;
}

export const Condition: React.FunctionComponent<Props> = ({
  cond,
  children,
}) => {
  const [trueResult, falseResult] =
    React.Children.count(children) === 1
      ? [children, null]
      : React.Children.toArray(children);

  return cond
    ? (trueResult as React.ReactElement | null)
    : (falseResult as React.ReactElement | null);
};
